import { onLCP, onCLS, onINP } from 'web-vitals'

export interface VitalSample {
  metric: 'LCP' | 'CLS' | 'INP'
  value: number
  rating: 'good' | 'needs-improvement' | 'poor'
}

type VitalsReporter = (sample: VitalSample) => void

// Placeholder sink until Phase 3 lands track(): structured console line in dev so the
// perf budgets are observable on localhost. Swapped for track('web_vitals', ...) with
// consent gating when the analytics core ships — no network I/O happens here.
const devLog: VitalsReporter = (sample) => {
  if (import.meta.env.DEV) console.debug('[vitals]', sample.metric, sample.value, sample.rating)
}

let reporter: VitalsReporter = devLog

/** Phase 3 re-points this at track('web_vitals', ...) (Appendix A S3). */
export function setVitalsReporter(fn: VitalsReporter): void {
  reporter = fn
}

export function initWebVitals(): void {
  for (const register of [onLCP, onCLS, onINP]) {
    register((m) => reporter({
      metric: m.name,
      // CLS is unitless; report *1000 so every metric is an integer (Appendix B).
      value: Math.round(m.name === 'CLS' ? m.value * 1000 : m.value),
      rating: m.rating,
    }))
  }
}
